<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "ReportedType",
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      }
    },
    props: ["value"],
    data() {
      return {
        data: "",
        list: [
          {
            name: "整车报废电池接收接口",
            value: 1
          },
          {
            name: "整车报废电池出库接口",
            value: 2
          },
          {
            name: "梯次包生产接口",
            value: 3
          },
          {
            name: "梯次模块生产接口",
            value: 4
          },
          {
            name: "梯次单体生产接口",
            value: 5
          },
          {
            name: "编码报废接口",
            value: 6
          },
          {
            name: "质量报废接口",
            value: 7
          },
          {
            name: "编码入库接口",
            value: 8
          },
          {
            name: "质量入库接口",
            value: 9
          },
          {
            name: "回收资源接口",
            value: 10
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
